export default "__VITE_ASSET__ryvjlwYa__"